import React, { Component } from "react";
import { useHistory } from "react-router-dom";
import "./Login.css";
import {
  GOOGLE_AUTH_URL,
  ACCESS_TOKEN,
  TWITTER_AUTH_URL,
  CLIENT,
} from "../../constants";
import { getClientInfo, getCurrentUser, login } from "../../util/APIUtils";
import { Link, Redirect } from "react-router-dom";
import TwitterLogo from "../../img/Twitter-X.png";
import googleLogo from "../../img/google-logo.png";
import Alert from "react-s-alert";
import { getUrlParameter } from "../../util/DataUtils";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: null,
      twitterLoginURL: TWITTER_AUTH_URL,
      clientName: "",
    };
    this.loadCurrentlyClient = this.loadCurrentlyClient.bind(this);
  }

  loadCurrentlyClient() {
    const clientId = getUrlParameter(CLIENT, window.location.search);
    if (clientId) {
      getClientInfo(clientId)
          .then((response) => {
            this.setState({
              client: response,
            });
            localStorage.setItem(CLIENT, JSON.stringify(response));
          })
          .catch((error) => {
            this.setState({
              client: null,
            });
            console.log(error);
          });
    } else {
      var client = localStorage.getItem(CLIENT);
      this.setState({
        client: JSON.parse(client),
      });
    }
  }

  componentDidMount() {
    // If the OAuth2 login encounters an error, the user is Redirected to the /login page with an error.
    // Here we display the error and then remove the error query parameter from the location.
    if (this.props.location.state && this.props.location.state.error) {
      setTimeout(() => {
        Alert.error(this.props.location.state.error, {
          timeout: 5000,
        });
        this.props.history.replace({
          pathname: this.props.location.pathname,
          state: {},
        });
      }, 100);
    }

    const query = new URLSearchParams(this.props.location.search);
    const uid = query.get("uid");
    if (uid != null) {
      this.setState({
        twitterLoginURL: TWITTER_AUTH_URL + `&uid=${uid}`,
      });
    }
  }

  componentWillMount() {
    // const clientId = getUrlParameter(CLIENT, window.location.search);
    const searchParams = new URLSearchParams(window.location.search);
    const clientIdURL = searchParams.get("client");
    if (clientIdURL) {
      getClientInfo(clientIdURL)
          .then((response) => {
            this.setState({
              client: { ...response },
            });

            this.setState({
              clientName: response.name,
            });

            localStorage.setItem(CLIENT, JSON.stringify(response));
          })
          .catch((error) => {
            this.setState({
              client: null,
            });
            console.log(error);
          });
    } else {
      var client = JSON.parse(localStorage.getItem(CLIENT));
      if (client != null) {
        this.setState({
          client: client,
        });
        this.setState({
          clientName: client.name,
        });
      }
    }
  }

  render() {
    const newTwitterLoginUrl = this.state.twitterLoginURL;

    if (this.props.authenticated) {
      return (
          <Redirect
              to={{
                pathname: "/",
                state: { from: this.props.location },
              }}
          />
      );
    }

    return (
        <div className="login-container">
          <div className="login-content">
            <h1 className="login-title">
              Login to {this.props.client ? this.props.client.name : ""}
            </h1>
            <SocialLogin twitterLoginURL={newTwitterLoginUrl} />
            <div className="or-separator">
              <span className="or-text">OR</span>
            </div>
            <LoginForm {...this.props} />
            <span className="signup-link">
            New User? <Link to="/signup">Sign Up</Link>
          </span>
            <div className="forgotpassword-link">
              {" "}
              <span>
              <Link to="/forgot-password">Forgot Password</Link>
            </span>{" "}
            </div>
          </div>
        </div>
    );
  }
}

class SocialLogin extends Component {
  componentDidMount() {}

  render() {
    const twitterLoginURL = this.props.twitterLoginURL;
    return (
        <div className="social-login">
          <a className="btn btn-block social-btn google" href={GOOGLE_AUTH_URL}>
            <img src={googleLogo} alt="Google" /> Log in with Google
          </a>
          <a className="btn btn-block social-btn twitter" href={twitterLoginURL}>
            <img src={TwitterLogo} alt="Twitter" /> Log in with Twitter
          </a>
        </div>
    );
  }
}

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      clientId: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadCurrentlyClient = this.loadCurrentlyClient.bind(this);
  }

  loadCurrentlyClient() {
    var client = localStorage.getItem(CLIENT);
    if (this.props.hasOwnPropert("client")) {
      this.setState({
        clientId: this.props.client.clientId,
      });
    } else {
      this.setState({
        clientId: JSON.parse(client),
      });
    }
  }

  componentWillMount() {
    // const clientId = getUrlParameter(CLIENT, window.location.search);
    const searchParams = new URLSearchParams(window.location.search);
    const clientIdURL = searchParams.get("client");
    if (clientIdURL) {
      getClientInfo(clientIdURL)
          .then((response) => {
            this.setState({
              clientId: response.clientId,
            });
            localStorage.setItem(CLIENT, JSON.stringify(response));
          })
          .catch((error) => {
            this.setState({
              clientId: null,
            });
            console.log(error);
          });
    } else {
      var client = JSON.parse(localStorage.getItem(CLIENT));
      console.log(client);
      if (client != null) {
        this.setState({
          clientId: client.clientId,
        });
      }
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;

    this.setState({
      [inputName]: inputValue,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const loginRequest = Object.assign({}, this.state);

    login(loginRequest)
        .then((response) => {
          localStorage.setItem(ACCESS_TOKEN, response.accessToken);
          this.props.history.go({
            pathname: "/",
          });
          Alert.success("You're successfully logged in!");
        })
        .catch((error) => {
          Alert.error(
              (error && error.message) ||
              "Oops! Something went wrong. Please try again!"
          );
        });
  }

  render() {
    return (
        <form onSubmit={this.handleSubmit}>
          <div className="form-item">
            <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email"
                value={this.state.email}
                onChange={this.handleInputChange}
                required
            />
          </div>
          <div className="form-item">
            <input
                type="password"
                name="password"
                className="form-control"
                placeholder="Password"
                value={this.state.password}
                onChange={this.handleInputChange}
                required
            />
          </div>
          <div className="form-item">
            <button type="submit" className="btn-8">
              <span>Login</span>
            </button>
          </div>
        </form>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/user/login/Login.js